type IEnvironmentName = 'dev' | 'prod';

type IEnv = {
  [k in IEnvironmentName]: {
    environment: IEnvironmentName;
    apiEndpoint: string;
    apiRest: string;
    refreshTokenUri: string;
    version: string;
    dtsDemoEmailMode: number;
    magensaAuthHeader: string;
  };
};

const env: IEnv = {
  dev: {
    environment: 'dev',
    apiEndpoint: 'https://dev.gift-card.fastboy.dev/graphql',
    refreshTokenUri: 'https://dev.gift-card.fastboy.dev/api/auth/refresh_token',
    apiRest: 'https://dev.gift-card.fastboy.dev/rest/bamboo/upload-signature',
    magensaAuthHeader:
      'U0o5ODcwNzIxNS9NQUc5MzY4MjkyMjQ6NDFIT2ZQelhRYi5LISVnPw==',
    version: '1.1.3',
    dtsDemoEmailMode: 1,
  },
  prod: {
    environment: 'prod',
    apiEndpoint: 'https://sys.gift-card.fastboy.dev/graphql',
    apiRest: 'https://sys.gift-card.fastboy.dev/rest/bamboo/upload-signature',
    refreshTokenUri: 'https://sys.gift-card.fastboy.dev/api/auth/refresh_token',
    magensaAuthHeader: 'RFQ3NDA1MTMyMC9NQUc2MDM4ODM5MDc6SzZnQUFWRUA=',
    version: '1.1.3',
    dtsDemoEmailMode: 0,
  },
};

class AppEnv {
  static get = () =>
    env[import.meta.env.VITE_ENV as IEnvironmentName] ?? env.dev;
}

export default AppEnv;
